import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import type { ITemplate } from '../interfaces/templates'
import Default from './Default'
import { useEndGuidedWalk } from '../hooks/checkout'

const Catalog: FC<ITemplate> = ({ ...props }) => {
  /*
   * Ends any guided walk, as the cart and the summary do (COM-1501). A
   * shopper who backs out of a walk onto the catalog would otherwise keep its
   * return path, and their next *Cambiar* confirm from the cart would follow
   * it instead of returning to the cart.
   *
   * Mount-only, so it cannot undo a walk this screen starts: the catalog's
   * own `startGuidedWalk` writes the path at least a microtask after its
   * `runOnLoad`, after every effect of that commit, this one included.
   */
  useEndGuidedWalk()

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])
  return <Default {...props} />
}

export default Catalog
